import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Airfryer = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path
        d="M5.053 8.778v5.309c0 .098.024.15.042.176.02.03.048.053.087.073a.436.436 0 0 0 .166.043h9.06c.097 0 .149-.024.176-.042a.217.217 0 0 0 .072-.087.44.44 0 0 0 .043-.16V8.774a.307.307 0 0 0-.042-.176.216.216 0 0 0-.086-.072.435.435 0 0 0-.167-.043H5.345a.307.307 0 0 0-.176.042.216.216 0 0 0-.073.086.436.436 0 0 0-.043.167Zm9.354-.628v-.334H5.345a.967.967 0 0 0-.546.154.882.882 0 0 0-.299.343 1.1 1.1 0 0 0-.113.455v.006h.333-.333v5.313c0 .215.054.398.153.546.098.147.226.24.343.299a1.103 1.103 0 0 0 .455.113h.006l.001-.333v.333h9.062a.967.967 0 0 0 .547-.153.881.881 0 0 0 .298-.343 1.1 1.1 0 0 0 .113-.444v-.017l-.333-.001h.334V8.775a.967.967 0 0 0-.154-.547.881.881 0 0 0-.343-.298 1.101 1.101 0 0 0-.454-.114h-.007v.334Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M6.595 14.379c.184 0 .333.15.333.333v.938a.333.333 0 1 1-.666 0v-.938c0-.184.149-.333.333-.333ZM13.158 14.379c.184 0 .333.15.333.333v.938a.333.333 0 0 1-.667 0v-.938c0-.184.15-.333.334-.333ZM8.137 10.025c0-.184.149-.334.333-.334h2.813a.333.333 0 1 1 0 .667H8.47a.333.333 0 0 1-.333-.333ZM.637 1.587c0-.184.149-.333.333-.333h3.75a1.27 1.27 0 0 1 1.226.937h7.211a1.27 1.27 0 0 1 1.271 1.271v1.875a1.27 1.27 0 0 1-1.27 1.27H6.594a1.27 1.27 0 0 1-1.27-1.27V2.525a.604.604 0 0 0-.605-.604H.97a.333.333 0 0 1-.333-.334ZM5.99 2.858v2.48a.604.604 0 0 0 .604.603h6.562a.604.604 0 0 0 .604-.604V3.462a.604.604 0 0 0-.604-.604H5.991Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M8.47 2.191c.184 0 .333.15.333.334v3.75a.333.333 0 1 1-.666 0v-3.75c0-.184.149-.334.333-.334ZM11.283 2.191c.184 0 .333.15.333.334v3.75a.333.333 0 0 1-.667 0v-3.75c0-.184.15-.334.334-.334Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

Airfryer.category = 'product-category';

Airfryer.displayName = 'Airfryer';
